export const easeOutInQuint = [0.23, 1, 0.32, 1];